// extracted by mini-css-extract-plugin
export default {"dotted":"application-form-fields_dotted__KrCwa","underline":"application-form-fields_underline__QNf9N"};